export default {
    attachments: {
        restart_label: 'Start over without {name}',
        restart_title: 'Start a new chat without attachments?',
        restart_description: 'The agent may already have used {name}. Start a fresh chat without the attached files or earlier replies. Your original conversation and library files will stay available. You can attach the correct files before continuing.',
        restart_action: 'Start without attachments',
        cancel: 'Keep this chat',
    },
    experience: {
        insufficient_data: 'Not enough data to score these ideas yet.',
        sample_notice: 'Sample preview · Nothing here creates an order.',
        sample_hint: 'Preview the archive with sample orders.', sample_show: 'Show sample orders', sample_exit: 'Show real orders', sample_order: 'Sample order',
        sample_notes_title: 'What would you like to change?', sample_notes_hint: 'Keep the structure of this brief and add your changes below.',
        sample_notes_placeholder: 'For example: Make this 30 seconds, use the new footage, and update the closing message.',

        preparing_edit: 'Preparing your edit…',
        preparing_work: 'Getting ready…',
        reading: 'Preparing files…', reading_hint: 'Uploading and reading your documents before we shape the brief.',
        read_failed: 'A document could not be read yet. It is saved in your media library, but has not been attached to this message. Please try again before continuing.',

        empty_title: 'Your next great edit starts here',
        empty_description: 'This workspace has no saved orders yet. Start a brief now. When your team saves an order, it will appear here to use again.',
        empty_step_one: '1 · Share your idea', empty_step_two: '2 · Review your brief', empty_step_three: '3 · Send to your editor',
        empty_start: 'Start a brief', empty_back: 'Back to starting options',

        help: 'Help me choose', idea: 'I have an idea', reuse: 'Use a previous order',
        help_hint: 'Explore three directions tailored to your footage. We’ll shape the brief together.',
        idea_hint: 'Share your direction or attach a brief. We’ll help with the missing details.',
        reuse_hint: 'Find a past brief, then tell us what to keep or change.',
        footage: 'Your footage', example_label: 'A little inspiration',
        example: 'A 60-second LinkedIn video for potential customers. Show the delivery experience and end with an invitation to learn more.',
        next: 'Next, we’ll review your direction together before anything goes to editing.',
        glance: 'Your edit at a glance', details: 'Full brief & editing instructions',
        audience: 'Who it’s for', goal: 'What it should achieve', channel: 'Where it will live',
        length: 'Length', format: 'Format', cta: 'What viewers should do next',
        missing: 'To confirm', missing_hint: 'Some key details still need confirming. Add them in the brief or discuss them in chat.',
        reuse_title: 'Your starting point', reuse_note: 'We’ll use this saved brief as a starting point. In chat, confirm what to keep, update the footage and add your notes. Selecting it does not place an order.',
        no_description: 'No brief preview is available. Review its details in chat before sending to editing.',
        relevance: 'AI visibility relevance', estimate: 'Editorial estimate · not a prediction of reach',
        why: 'Why this fits', hide: 'Hide details', assessing: 'Assessing…', unscored: 'Not scored yet',
        evidence: 'Evidence', improve: 'How to strengthen it',
        breakdown: 'Question {question}/25 · Footage {footage}/25 · Brand {brand}/25 · Clarity {clarity}/25',
    },
    writing: { cta: 'Call to action', explore_angle: 'Explore angle', sharpen_intro: 'Sharpen intro', review_draft: 'Review draft', actions: 'Draft actions', copy_draft: 'Copy draft' },
    history: {
        refreshing: 'Checking for newer versions…',
        refresh_error: 'Couldn’t refresh history. Previously loaded versions are still available.',
        button: 'History', title: 'Draft history',
        description: 'Compare full drafts before choosing what to keep.',
        change_legend: 'Changed sections: amber in the saved version, green in the current draft.',
        identical: 'These drafts have the same content.',
        comparison_unavailable: 'Both full drafts are shown. Highlighting is unavailable for this large comparison.',
        back: 'Back to editor', current: 'Current draft', current_help: 'Read-only comparison. Your draft stays unchanged until you restore.',
        keeps_newer: 'Restoring replaces the current draft with the version on the left. Your newer text stays in history.',
        loading: 'Loading saved versions…', load_error: 'Could not load draft history.', retry: 'Try again',
        empty: 'No saved versions yet.', versions: 'Version to restore', version: 'Version {number}',
        preview: 'Read-only preview · saved text and formatting', choose: 'Choose a version to preview.',
        restore: 'Restore version {number}', restoring: 'Restoring…',
        restore_error: 'Could not restore this version', kept: 'Your current draft is unchanged. Please try again.',
    },
    brain_sync: {
        failed_title: 'Your Brand Brain could not sync',
        failed_retry: 'Some Brand Brain sources could not sync. Retry the brand sync or contact support if it keeps failing.',
        failed_readonly: 'Some Brand Brain sources could not sync. Ask a channel administrator to retry the sync or contact support.',
        retry: 'Retry sync',
        retrying: 'Restarting sync...',
        progress: '{done} of {total} sources synced',
        failures: '{count} failed',
        queued: 'Brand Brain sync queued. This page opens the chat after a source syncs successfully.',
        empty_queue: 'No Brand Brain sources were queued. Please contact support.',
        forbidden: 'You do not have permission to retry this sync. Ask a channel administrator for help.',
        retry_error: 'Could not restart the Brand Brain sync. Please try again or contact support.',
    },
    // Eddie chat -- artifact renderers
    artifact: {
        download: 'Download',
        copy: 'Copy',
        copied: 'Copied',
        copy_link: 'Copy link',
        share: 'Share',
        share_tweet: 'Post on X',
        share_linkedin: 'Post to LinkedIn',
        share_facebook: 'Post to Facebook',
        share_threads: 'Post to Threads',
        more: 'More actions',
        open: 'Open',
        add_to_folder: 'Add to folder',
        add_to_sales_materials: 'Add to Social Sharing',
        rename: 'Rename',
        delete: 'Delete',
        edit: 'Edit',
        regenerate: 'Regenerate',
        retry: 'Try again',
        generating: 'Generating…',
        creating_image: 'Creating image…',
        expand: 'View full size',
        close: 'Close',
        previous_image: 'Previous image',
        next_image: 'Next image',
        draft: 'Draft',
        draft_sub: 'Long-form draft',
        failed: "Couldn't generate this. Try again.",
        play: 'Play',
        slide_count: '{count} slides',
        page_count: '{count} pages',
        ai_generated: 'AI-generated',
    },
    // Eddie chat -- approval-gate card (T21)
    approval: {
        heading: 'Approval needed',
        action_label: 'Action',
        args_label: 'Parameters',
        approve: 'Approve',
        edit: 'Edit',
        reject: 'Reject',
        respond: 'Respond',
        edit_heading: 'Edit action parameters',
        edit_placeholder: 'Paste or type the updated JSON parameters...',
        edit_apply: 'Apply edit',
        message_placeholder: 'Add a message...',
        cancel: 'Cancel',
    },
    // Left rail sidebar -- organization label + sessions list
    sidebar: {
        organization: 'Organization',
        open_sessions: 'Open sessions',
        close_sessions: 'Close sessions',
    },
    // Edit-direction checklist panel (mobile open/close affordances)
    checklist: {
        is_social: 'Made for social media',
        edit: 'Edit brief',
        save: 'Save changes',
        cancel: 'Cancel',
        edit_field: 'Edit field',
        select_value: 'Choose a value',
        custom_value: 'Custom…',
        editing_field: 'Editing',
        unsaved_field: 'Save or cancel to finish this edit.',
        add_value: 'Add a value',
        edit_hint: 'Review your brief. Choose Edit brief to make changes.',
        draft_hint: 'Editing draft. Save your changes when you’re ready.',
        line_hint: 'One item per line',
        timeline: 'Timeline',
        speakers: 'Speakers and lower thirds',
        screen_text: 'On-screen text',
        visuals: 'Visual additions',
        add_entry: 'Add entry',
        remove_entry: 'Remove entry {number}',
        timestamp: 'Time',
        speaker: 'Speaker',
        add_speaker: 'Add speaker',
        add_platform: 'Add platform',
        remove_platform: 'Remove platform {number}',
        select_platform: 'Choose a platform',
        no_platforms: 'No platforms yet. Add the ones this will run on.',
        add_step: 'Add step',
        step_number: 'Step {number}',
        move_up: 'Move step up',
        move_down: 'Move step down',
        remove_step: 'Remove step {number}',
        remove_speaker: 'Remove speaker {number}',
        brand_book: 'Brand book',
        choose_brand: 'Choose a brand book',
        loading_brand: 'Loading brand book…',
        brand_error: 'Could not load the brand book. Try again.',
        no_brands: 'No brand books are available.',
        retry: 'Retry',
        creator: 'Credit',
        notes: 'Details',
        open: 'Open checklist',
        open_short: 'Checklist',
        close: 'Close checklist',
    },
    // Session picker (T20) -- lists org-shared sessions for a content item
    session_picker: {
        heading: 'Your chats',
        actions_aria: 'Actions for {title}',
        rename: 'Rename',
        delete: 'Delete',
        new_task: 'Create new',
        new_task_aria: 'Create something new',
        list_aria: 'Existing chats',
        open_session_aria: 'Open session: {title}',
        delete_session_aria: 'Delete session: {title}',
        rename_session_aria: 'Rename session: {title}',
        rename_input_aria: 'Session title',
        delete_confirm_title: 'Delete this chat?',
        delete_confirm_body: 'This permanently removes the chat and any assets it generated. This can\'t be undone.',
        delete_confirm_cancel: 'Cancel',
        delete_confirm_confirm: 'Delete chat',
        loading_aria: 'Loading chats',
        untitled_session: 'Untitled session',
        // Row label: stable intent on the left, what the chat is about on the
        // right. Keeps same-type chats distinguishable without letting the
        // agent's shifting working_title rename the row.
        label_with_intent: '{intent} · {detail}',
        submitted: 'Submitted',
        in_progress: 'In progress',
        empty: 'Your next creation starts here',
        empty_sub: 'Pick a task above to get going. It stays saved here for your whole team.',
        just_now: 'Just now',
        minutes_ago: '{n}m ago',
        hours_ago: '{n}h ago',
        yesterday: 'Yesterday',
        days_ago: '{n}d ago',
    },
    // Thumbs up/down under the agent's answers.
    feedback: {
        helpful: 'Helpful',
        not_helpful: 'Not helpful',
        dialog_title: 'What went wrong?',
        dialog_placeholder: 'Tell us what you expected instead.',
        send: 'Send',
        // Backs out of a thumbs down before it is filed. Nothing is recorded
        // until Send, so this discards rather than deletes.
        cancel: 'Cancel',
        reasons: {
            hallucination: 'Hallucination',
            incorrect_info: 'Incorrect information',
            ignored_instructions: 'Did not follow instructions',
            off_brand: 'Off-brand voice or style',
            incomplete: 'Incomplete',
            too_slow: 'Took too long',
            other: 'Something else',
        },
        // Offered after a thumbs up is already saved, so it asks rather than
        // requires. Keys match the stored codes.
        positive_prompt: 'What worked?',
        // Asked once the conversation has produced something, so there is
        // actually an outcome to judge. Phrased about the whole conversation
        // rather than the last answer, which is what a customer who just got a
        // clip or a blog is thinking about.
        conversation_prompt: 'Did this conversation help you?',
        conversation_positive_prompt: 'What worked?',
        conversation_thanks: 'Thanks for telling us.',
        // These name the VALUE the work had, not how the model behaved. Accurate
        // / complete / fast read as a report card: an answer can be all three and
        // still need a rewrite before anyone can use it. No "Something else"
        // here, unlike `reasons` above, because a tag on praise is optional and
        // an untagged thumbs up already means exactly that.
        positive_reasons: {
            good_saved_time: 'Saved me time',
            good_ready_to_use: 'Ready to use',
            good_on_brand: 'Sounded like us',
            good_followed_direction: 'Nailed the brief',
        },
    },
    // Intent-driven entry CTAs (T20) -- shown when no sessions exist
    entry: {
        media_preparation_title: 'Preparing your media',
        write_while_waiting: 'Want to start writing while you wait?',
        preparing_awaiting_status: 'Waiting for a processing update',
        preparing_dispatched: 'Sent for analysis — waiting for an update',
        write_without_media: 'Start writing without this media',
        write_without_media_help: 'Start a written draft from your instructions. This media is not available to use yet.',

        heading: 'What would you like to do?',
        subheading: 'Choose a task to get started.',
        hero: 'Multiply this into content you can share',
        hero_2: 'Turn this into everything you need to share',
        hero_3: 'One video, a dozen ways to share it',
        hero_4: 'Everything this content could become',
        hero_5: 'Give this a second life, everywhere',
        composer_placeholder: 'Try "Cut a 60-second version for LinkedIn"...',
        composer_placeholder_dynamic: 'Try "{title}"...',
        grid_aria: 'Suggestions',
        recommendations_heading: 'Suggested from this content',
        recommendations_aria: 'Recommendations from this content',
        recommendations_loading: 'Crafting content recommendations...',
        preparing_title: 'Preparing your media',
        preparing_attention_title: 'Your media needs attention',
        preparing_sub: 'Analyzing your media so you can start creating.',
        // Shown INSTEAD of the spinner when the pipeline has stopped. Each says
        // which of three genuinely different things happened, because the old
        // scene rendered all of them as the same endless sweep.
        preparing_stalled: 'The analysis has stopped making progress. Please try again.',
        preparing_failed: "We couldn't analyze this media. Please try again. If it keeps happening, contact support.",
        preparing_never_started: "We couldn't get the analysis started. Please try again.",
        preparing_recovering: "We've requested a fresh analysis. You can check back here for updates.",
        preparing_support: "We couldn't finish preparing this media. Please contact support for help.",
        // The action for the three stuck states above. Older content predates the
        // analysis pipeline (or lost its dispatch), and until this existed the
        // screen explained the problem with no way to act on it.
        reanalyze_cta: 'Try again',
        reanalyze_starting: 'Requesting a fresh analysis…',
        reanalyze_started: 'Analysis requested',
        reanalyze_no_media: 'There is no media to analyze here. Add a video or audio file to get started.',
        reanalyze_no_access: "You can't restart this analysis. Ask your channel admin for help.",
        reanalyze_failed: "We couldn't start the analysis. Please try again.",
        preparing_tease_eyebrow: 'Tips',
        preparing_tip_describe_title: 'Describe what you want',
        preparing_tip_describe_desc: 'Plain English works fine, like "cut a 60-second version for LinkedIn." No forms to fill out.',
        preparing_tip_mention_title: 'Loop in a teammate',
        preparing_tip_mention_desc: "Use {'@'}Name in the composer. They'll see the same chat and can jump in on their own.",
        preparing_tip_saved_title: 'Nothing gets lost',
        preparing_tip_saved_desc: 'Every chat is saved here. Pick up exactly where you left off, whenever you come back.',
        preparing_tip_recommendations_title: 'Grounded suggestions',
        preparing_tip_recommendations_desc: "Once ready, you'll see specific ideas already pulled from this video, not generic prompts.",
        preparing_tip_media_title: 'Everything in one place',
        preparing_tip_media_desc: 'Clips, drafts, and images you create in chat all land in the Media tab automatically.',
        preparing_tip_multiplayer_title: 'Work together, live',
        preparing_tip_multiplayer_desc: "Invite a teammate into the same chat. You'll both see replies as they happen.",
        edit_request: 'Request a video edit',
        edit_request_desc: 'Create a brief for your video edit.',
        creation_title: 'What will you create?',
        creation_placeholder: 'Describe what you have in mind…',
        outcome_write_blog: 'Choose the right format.',
        outcome_write_social: 'Start a conversation.',
        outcome_make_clips: 'Find key moments.',
        outcome_create_podcast: 'Make it heard.',
        outcome_generate_image: 'Picture your idea.',
        outcome_create_infographic: 'Make the details clear.',
        editor_path_title: 'Request a video edit',
        editor_path_action: 'Create a brief',
        editor_path_desc: 'Tell us what you need. Get the finished video when it’s ready.',
        ai_path_title: 'Create something now',
        ai_path_desc: 'Made with AI. Ready to review here.',
        edit_request_disabled: 'Open this from a specific piece of content to request an edit.',
        edit_request_in_flight: 'This content is already in editing. Duplicate it or request a variant to make another edit.',
        edit_request_not_ready: 'Still preparing this content — you\'ll be able to request an edit shortly.',
        make_clips: 'Clip Builder',
        make_clips_desc: 'Turn the best moments into short, shareable clips.',
        build_clips: 'Clip builder',
        build_clips_desc: 'Pick the exact moments and aspect ratios, and we cut to them.',
        write_draft: 'Draft',
        write_blog: 'Write content',
        write_blog_desc: 'Blogs, articles, knowledge base articles, data sheets and case studies, informed by your brand and sources.',
        write_social: 'Write social posts',
        write_social_desc: 'Ready-to-post captions and copy for your channels.',
        create_podcast: 'Create audio brief',
        create_podcast_desc: 'Repackage this as an audio brief.',
        generate_image: 'Generate an image',
        generate_image_desc: 'A custom image drawn from this content.',
        create_infographic: 'Create an infographic',
        create_infographic_desc: 'Explain this content in a designed layout.',
        general_chat: 'Ask anything',
        general_chat_desc: 'Chat about this content.',
        use_edit_form: 'Use Edit Request Form',
        // R6-F-001: shown when the content type isn't supported by Eddie yet
        // (e.g. a podcast recording) — instead of dead-ending into a broken
        // intent surface.
        unsupported_title: "Chat isn't available for this content yet",
        unsupported_body:
            'Chat works on videos and media files. Support for this content type is coming soon.',
    },
    // SM-9600 — the resume decision on "Request an edit". There is one live edit
    // request per content and reopening it is correct; what was wrong is that it
    // happened silently, inside somebody else's older conversation, while quietly
    // discarding an instruction the user had already supplied.
    resume_edit_draft: {
        title: 'Resume this edit request?',
        body: 'This content already has an edit request in progress. There can only be one at a time, so continuing opens the existing draft instead of starting a new one.',
        body_submitted: 'This content already has an edit request, and its brief has been sent to editing. There can only be one at a time, so continuing opens it instead of starting a new one.',
        untitled: 'Untitled edit request',
        owner: 'Started by {name}',
        owner_label: 'Started by',
        updated: 'Last updated {when}',
        updated_label: 'Last updated',
        instruction_kept: 'Your instruction will be placed in the message box — review it and press send when you\'re ready. Nothing is sent by opening the draft.',
        confirm: 'Resume draft',
        cancel: 'Cancel',
        start_fresh: 'Start a new edit request instead',
        toast_title: 'Your instruction is in the message box',
        toast_body: 'It has not been sent yet — review it and press send.',
    },
    // Composer hint line (below the input)
    composer: {
        mention_hint: "Multi-user mode: Messages go to the AI by default. Use {'@'}Name to message a teammate.",
        attach: 'Attach a brief, document or image',
        remove_attachment: 'Remove {name}',
    },
    // Multiplayer presence roster (T22) -- shows who else is in the session
    presence: {
        roster_aria: 'Session participants',
        prompting: '{name} is prompting...',
        // A bare `@` is vue-i18n's linked-message trigger char — it breaks
        // compilation of the WHOLE message (including `{name}`) unless
        // escaped as a literal via `{'@'}` (see simple-login.js precedent).
        one_other: "{name} is here — mention with {'@'}",
        n_others: "{count} teammates here — mention with {'@'}",
    },
    // @-mention dropdown in the composer -- scoped to live session participants
    mention: {
        aria_label: 'Mention a teammate',
        no_matches: 'No teammates match "{query}"',
    },
    // Session busy banner (T22) -- shown when session is locked by another user
    busy: {
        banner_label: '{name} is editing this session',
        stopped_label: 'Stopped at your request.',
        start_new_edit_request: 'Start a new edit request',
        // SM-9491: the lock is the user's own stopped turn still finishing, so
        // say that rather than blaming an unnamed "another user".
        stopping_previous: 'Your previous message is still stopping. Send it again in a moment.',
        retry_label: 'Try again',
    },
    // Clip Builder -- the scripted (no-LLM) interview behind the build_clips chip.
    // Copy is regenerated from these keys on rehydration; the server stores only
    // the structured answers, never prose.
    clip_builder: {
        opener: "Let's cut clips to your exact moments, styled with your brand.",
        moments_prompt: 'Which moments should I cut? Type ranges like "2:14 to 2:41" (several are fine), or let me pick for you.',
        choose_for_me: 'Choose for me',
        choose_for_me_desc: 'I scan the video and pick the strongest moments.',
        count_prompt: 'How many clips should I pick? 4 works well for most videos.',
        ratios_prompt: 'Which shapes do you need? Landscape and portrait cover most channels.',
        finish_prompt: 'How should these clips end?',
        finish_brand: "Use my brand's setting",
        finish_hard_cut: 'Hard cut (recommended)',
        finish_fade_black: 'Fade to black',
        finish_fade_white: 'Fade to white',
        ratio_landscape: 'Landscape',
        ratio_landscape_desc: '16:9, for YouTube and the web.',
        ratio_portrait: 'Portrait',
        ratio_portrait_desc: '9:16, for Reels, TikTok, and Shorts.',
        ratio_square: 'Square',
        ratio_square_desc: '1:1, for feeds.',
        style_intro_line: "Here's how your clips will be styled, straight from your Styles tab:",
        style_logo_on: 'logo on, {corner}',
        style_logo_off: 'no logo',
        style_captions_on: 'captions in {preset} style, {font}',
        style_captions_off: 'no captions',
        style_safe_zone_on: '; kept inside the platform safe zone',
        style_stings: 'With your {parts}.',
        style_intro: 'intro',
        style_outro: 'outro',
        style_none: 'No clip style is set up yet, so these clips will use the default look. You can style future clips under [Brand Brain, Assets](/brand-brain?tab=assets).',
        confirm_prompt: 'Cut the clips with this look? Styling changes live in the Styles tab.',
        confirm_yes: 'Cut my clips',
        confirm_no: 'Not now',
        canceled: 'No problem. Reopen Clip builder whenever you are ready.',
        dispatched: 'On it. Cutting your clips now; this can take a few minutes.',
        done: 'Your clips are ready. They are also saved in the Media tab.',
        failed_qc: "We couldn't create a clip from this section. Try a different moment with clear speech at the start and end.",
        failed: "We couldn't create the clips. Please try again. If it keeps happening, contact support.",
        unavailable: "Clip Builder isn't available right now because the render service didn't respond. Nothing was sent anywhere else.",
        unavailable_generic: "Something went wrong reaching the render service. Nothing was sent anywhere else.",
        retry_prompt: 'Want me to try again?',
        retry: 'Try again',
        busy: 'A clip job is already running in this chat. Wait for it to finish before starting another.',
        taking_long: 'Rendering is taking longer than usual. Your clips will land in the Media tab when they finish.',
        use_options: 'Pick one of the options above to continue.',
        flow_done: 'This clip task is finished. Start a new task from the picker to make more clips.',
        err_none: 'I couldn\'t find a time range in that. Type it like "2:14 to 2:41".',
        err_inverted: 'That range ends before it starts ({range}). Type it like "2:14 to 2:41".',
        err_too_short: 'Each clip needs at least 12 seconds ({range}). Widen the window and try again.',
        err_out_of_bounds: 'That range runs past the end of this video ({range}).',
    },
    // Job progress rows (T22) -- per-job progress and artifact display
    job_progress: {
        queued: 'Waiting to start…',
        running: '{kind} in progress',
        processing: 'Processing...',
        complete: '{kind} complete',
        failed: '{kind} failed',
    },
    // Phases narrated on the image-generation card while a render is in flight.
    // Used only when the agent has streamed no progress message of its own.
    image_generation: {
        creating: 'Creating image',
        sketching: 'Sketching it out',
        blocking: 'Blocking in the composition',
        detail: 'Adding detail',
        finishing: 'Finishing touches',
    },
    // Message bubble attribution (T22) -- remote user message label
    message: {
        from_sender: 'from {name}',
    },
    // Media library (T16) -- grid with category filters and pagination
    media: {
        title: 'Media',
        subtitle: '{count} items · everything created from chat, plus what you upload',
        empty: 'Your ideas, made real',
        empty_sub: 'Describe what you need in chat. The media you create gathers here, ready to use.',
        empty_cta: 'Start creating',
        upload: 'Upload',
        upload_hint: 'Upload media from your device',
        uploading: 'Uploading {count} file(s)…',
        uploading_percent: 'Uploading {count} file(s)… {percent}%',
        upload_drop: 'Drop to upload',
        upload_drop_hint: 'Video, image, audio or document. Up to {max} at a time.',
        uploaded: '{count} file(s) uploaded',
        upload_partial: '{count} uploaded, {failed} could not be uploaded',
        upload_failed: 'Could not upload. Please try again.',
        upload_too_large: 'That file is too large to upload here. Try a smaller file.',
        upload_file_too_large: '"{name}" is too large. Each file must be under {max}MB.',
        upload_too_many: 'You can upload up to {max} files at a time.',
        upload_forbidden: "You don't have permission to attach files here. Ask your channel admin for help.",
        untitled: 'Untitled',
        more: 'More actions',
        delete_confirm: 'Delete "{title}"? This removes it from the media library.',
        delete_confirm_bulk: 'Delete {count} selected items? This removes them from the media library.',
        deleted: 'Media deleted',
        deleted_bulk: '{count} items deleted',
        delete_failed: 'Could not delete this media. Please try again.',
        rename_title: 'Rename media',
        rename_placeholder: 'Media name',
        rename_save: 'Save',
        renamed: 'Renamed',
        rename_failed: 'Could not rename this media. Please try again.',
        add_to_folder_soon: 'Adding media to folders is coming soon.',
        added_to_folder: 'Added {count} to "{folder}"',
        add_to_sales_materials_failed: "This item isn't linked to a piece of content, so it can't be added to Social Sharing.",
        add_to_folder_failed: 'Could not add to folder. Please try again.',
        add_to_folder_nothing: "Nothing was added — these items have no file to put in a folder.",
        selected: '{count} selected',
        clear_selection: 'Clear selection',
        select_item: 'Select item',
        folder_picker: {
            title: 'Add {count} to folder',
            search: 'Search folders',
            loading: 'Loading folders…',
            none: 'No folders yet',
            in_parent: 'in {parent}',
            new: 'Or create a new folder',
            confirm: 'Add to folder',
        },
        filters: {
            all: 'All',
            audio: 'Audio',
            video: 'Videos',
            image: 'Images',
            document: 'Documents',
        },
        sort: {
            label: 'Sort by',
            newest: 'Newest',
            oldest: 'Oldest',
            name_asc: 'Name (A–Z)',
            name_desc: 'Name (Z–A)',
        },
        date: {
            today: 'Today',
            yesterday: 'Yesterday',
            days_ago: '{count}d ago',
        },
        pagination: {
            label: 'Pagination',
            prev: 'Previous page',
            next: 'Next page',
        },
    },
    // Error rows and job failure states (T19) -- friendly copy + retry control
    errors: {
        /** Default fallback shown when no agent-supplied message is available. */
        default: 'Something went wrong, try again later.',
        /** Retry button label on recoverable error rows. */
        retry: 'Try again',
        /** Shown when a job/artifact fails without a specific agent message. */
        job_failed: "We couldn't finish creating this. Please try again.",
    },
}
